import { useTranslation } from 'react-i18next';

/**
 * This component represent planner no data state.
 * When server return empty response for filters specified filters
 */
export const PlannerNoDataState = () => {
  const { t } = useTranslation(['authenticated.planner']);

  return (
    <div className="absolute top-[6.2rem] py-[22px] pl-48 pr-4">
      <p className="text-sm font-normal">{t('noDataState.title')}</p>
    </div>
  );
};
